import * as Yup from "yup";

export const deprovisionValidation = (questions: string[]) =>
  Yup.object().shape({
    interviewBy: Yup.string().required("This field is required"),
    date: Yup.date().nullable().required("Date is required"),
    typeOfExit: Yup.string().required("Type of exit is required"),
    appraiserComments: Yup.array().of(Yup.string().required("This field is required")).min(questions.length, `At least ${questions.length} comments are required`),
  });
